import React from "react";
import { useTranslation } from "react-i18next";
import {
  useRemoveIdentityProvider,
  useRetrieveCurrentPlanzone,
} from "@planzone/view-models";

import { Button } from "@common/button";
import { Modal } from "@common/modal";
import { Props } from "./types";
import styles from "./styles.scss";

function RemoveIdentityProvider({ identityProvider, cancel }: Props) {
  const { isRequestPending, removeIdentityProvider } =
    useRemoveIdentityProvider(identityProvider);
  const { planzone } = useRetrieveCurrentPlanzone();
  const { t } = useTranslation();

  return (
    <Modal
      header={t("removeIdentityProvider.title")}
      headerClassName={styles.header}
      close={cancel}
    >
      <div className={styles.removeIdentityProvider}>
        <p className={styles.message}>{t("removeIdentityProvider.message")}</p>
        <div className={styles.button}>
          <Button
            type="delete"
            status={isRequestPending ? "pending" : "none"}
            isDisabled={isRequestPending}
            press={() =>
              removeIdentityProvider({
                planzone,
                identityProvider,
              })
            }
          >
            {t("removeIdentityProvider.confirm")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export { RemoveIdentityProvider };
